import React from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    makeStyles,
    Theme,
} from '@material-ui/core'
import { UNIT_COLUMN_DEFINITIONS } from '../projectUnitColumnDefinitions'

const useStyles = makeStyles((theme: Theme) => ({
    definitionBlock: {
        marginBottom: theme.spacing(2.5),
        '&:last-child': {
            marginBottom: 0,
        },
    },
    definitionBlockFoundation: {
        marginBottom: theme.spacing(2.5),
        padding: theme.spacing(1.5),
        backgroundColor: theme.palette.grey[50],
        borderRadius: theme.shape.borderRadius,
        borderLeft: `4px solid ${theme.palette.primary.main}`,
    },
    definitionLabel: {
        fontWeight: 600,
        marginBottom: theme.spacing(0.5),
    },
    definitionText: {
        color: theme.palette.text.secondary,
        lineHeight: 1.6,
    },
    definitionTerm: {
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
}))

interface Props {
    open: boolean
    onClose: () => void
}

const renderDefinitionParts = (
    parts: { text: string; bold?: boolean }[],
    termClassName: string,
) =>
    parts.map((part, index) =>
        part.bold ? (
            <strong key={index} className={termClassName}>
                {part.text}
            </strong>
        ) : (
            <span key={index}>{part.text}</span>
        ),
    )

export const ProjectUnitDefinitionsModal: React.FC<Props> = ({
    open,
    onClose,
}) => {
    const classes = useStyles()

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            aria-labelledby="unit-definitions-dialog-title"
        >
            <DialogTitle id="unit-definitions-dialog-title">
                Column Definitions
            </DialogTitle>
            <DialogContent dividers>
                {UNIT_COLUMN_DEFINITIONS.map(
                    ({ label, parts, isFoundation }) => (
                        <div
                            key={label}
                            className={
                                isFoundation
                                    ? classes.definitionBlockFoundation
                                    : classes.definitionBlock
                            }
                        >
                            <Typography
                                variant="subtitle1"
                                className={classes.definitionLabel}
                            >
                                {label}
                            </Typography>
                            <Typography
                                variant="body2"
                                component="div"
                                className={classes.definitionText}
                            >
                                {renderDefinitionParts(
                                    parts,
                                    classes.definitionTerm,
                                )}
                            </Typography>
                        </div>
                    ),
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}
